<template>
        <div class="core-view-individual">
          <router-view />
        </div>
</template>
<script>
export default {
    name: 'core-view-individual'
}
</script>
<style scoped lang="stylus">
    .core-view-individual
        padding-top 50px
        padding-bottom 50px
</style>